// Общие мелочи видов аналитики документов (графики и таблицы - из chartKit журнала)
import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { WEEKLY_FROM_DAYS } from './analyticsFormat';
import { BucketBy } from './analyticsTypes';

/** Высота основных графиков */
export const HEIGHT = 320;
/** С какого числа точек под графиком появляется ползунок масштаба */
export const BRUSH_FROM = 60;

export const toggleIn = (list: string[], key: string): string[] => (list.indexOf(key) !== -1 ? list.filter(k => k !== key) : list.concat(key));

/**
 * Шаг графика: по умолчанию - дни, для длинного периода - недели; выбор пользователя сохраняется до смены вида.
 * Возвращает действующий шаг и функцию выбора.
 */
export function useBucketBy(days: number): [BucketBy, (by: BucketBy) => void] {
  const [choice, setChoice] = useState<BucketBy | null>(null);
  return [choice || (days > WEEKLY_FROM_DAYS ? 'week' : 'day'), setChoice];
}

/** Переключатель «По дням / По неделям» в шапке карточки */
const ByToggleBase: React.FC<{ value: BucketBy; onChange: (by: BucketBy) => void }> = ({ value, onChange }) => (
  <ToggleButtonGroup
    size="small" exclusive value={value} onChange={(_, v: BucketBy | null) => { if (v) onChange(v); }}
    sx={{ height: 30, '& .MuiToggleButton-root': { px: 1.25, py: 0, fontSize: '0.76rem', fontWeight: 600, textTransform: 'none' } }}
  >
    <ToggleButton value="day">По дням</ToggleButton>
    <ToggleButton value="week">По неделям</ToggleButton>
  </ToggleButtonGroup>
);
export const ByToggle = React.memo(ByToggleBase);

/** Маленький переключатель внутри карточки (вид графика, метрика) */
export function MiniToggle<T extends string>({ value, options, onChange }: { value: T; options: Array<{ value: T; label: string }>; onChange: (v: T) => void }) {
  return (
    <ToggleButtonGroup
      size="small" exclusive value={value} onChange={(_, v: T | null) => { if (v) onChange(v); }}
      sx={{ height: 26, '& .MuiToggleButton-root': { px: 1, py: 0, fontSize: '0.72rem', textTransform: 'none' } }}
    >
      {options.map(o => <ToggleButton key={o.value} value={o.value}>{o.label}</ToggleButton>)}
    </ToggleButtonGroup>
  );
}
